
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const RoomsPage = lazy(() => import('../pages/rooms/page'));
const PubPage = lazy(() => import('../pages/pub/page'));
const MenuPage = lazy(() => import('../pages/menu/page'));
const MenuCategoryPage = lazy(() => import('../pages/menu/category/page'));
const MenuItemPage = lazy(() => import('../pages/menu/item/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/rooms',
    element: <RoomsPage />,
  },
  {
    path: '/pub',
    element: <PubPage />,
  },
  {
    path: '/menu',
    element: <MenuPage />,
  },
  {
    path: '/menu/:category',
    element: <MenuCategoryPage />,
  },
  {
    path: '/menu/:category/:item',
    element: <MenuItemPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
